/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'feedback': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M847.8 757.2H644.4l-99.8 183.2c-3.5 6.3-8.3 11.1-13.9 14.4l-.1.1c-.1.1-.1.1-.2.1-1.7 1.1-3.7 1.9-5.6 2.7-.5.2-1 .5-1.7.7-1.3.4-2.7.7-4.1 1-1.1.2-2.3.5-3.4.6-.9.1-1.7.1-2.5.1-1.7.1-3.3.1-5-.1-.3 0-.8-.1-1.1-.2-10.9-1.6-21.1-8.2-27.1-19.2l-99.7-183.3H176.9C115.1 757.2 65 702.5 65 635.1V187.3c0-67.5 50.1-122.1 111.8-122.1h670.9c61.8 0 111.8 54.8 111.8 122.1v447.8c.1 67.4-49.9 122.1-111.7 122.1zm37.4-569.9c0-22.5-16.7-40.7-37.3-40.7H177c-20.6 0-37.3 18.2-37.3 40.7v447.8c0 22.5 16.7 40.7 37.3 40.7h223.6v.8c12.8-.1 25.4 6.9 32.3 19.6l79.4 146.1 79.5-146.1c6.9-12.7 19.4-19.6 32.3-19.6v-.8h223.6c20.6 0 37.3-18.2 37.3-40.7h.1V187.3zM698.7 472.4c-20.6 0-37.3-18.2-37.3-40.7 0-22.5 16.7-40.7 37.3-40.7 20.6 0 37.3 18.2 37.3 40.7 0 22.5-16.7 40.7-37.3 40.7zm-186.4 0c-20.6 0-37.3-18.2-37.3-40.7 0-22.5 16.7-40.7 37.3-40.7 20.6 0 37.3 18.2 37.3 40.7 0 22.5-16.6 40.7-37.3 40.7zm-186.3 0c-20.6 0-37.3-18.2-37.3-40.7 0-22.5 16.7-40.7 37.3-40.7 20.5 0 37.2 18.2 37.3 40.7 0 22.5-16.7 40.7-37.3 40.7z" _fill="#070707"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/feedback.js